<template>
    <lay-row space="10"> 
        <lay-panel style="padding: 10px"> 
            <div style="margin-bottom: 10px;text-align: left;">
            <lay-button size="sm" @click="changeVisible11" type="primary">新增</lay-button>
          </div> 
            <lay-table  :height="'100%'" :columns="columns"  :data-source="dataSource"
            v-model:selected-keys="selectedKeys"> 
            <template v-slot:operator="{ row }">
              <lay-button size="xs" type="primary" @click="updateDomainname(row)">编辑</lay-button>
              <lay-button size="xs" type="danger" @click="deleteDomainname(row)">删除</lay-button>
            </template>

            
            <template #platform="{ row }"> 
                <span v-if="getPlatformName(row.platformId)">{{ getPlatformName(row.platformId) }}</span>
          </template>

          </lay-table>
       
        </lay-panel> 
    </lay-row>
  
  
  
    <lay-layer v-model="visible11" :shade="false" :area="['380px', '400px']" :btn="action11" title="添加域名/修改域名">
      <div style="padding: 20px;">
        <lay-form :model="domainname" ref="layFormRef11" >
              <lay-form-item label="域名" prop="domainName">
                <lay-input v-model="domainname.domainName"></lay-input>
              </lay-form-item>    
              <lay-form-item label="绑定平台" prop="platformId">
                <lay-select v-model="domainname.platformId" placeholder="请选择">
                    <lay-select-option
                                    v-for="platform in platformArr"
                                    :key="platform.id"
                                    :value="String(platform.id)"   
                                    :label="platform.name">
                                    </lay-select-option>
                    </lay-select>
              </lay-form-item>    

              <lay-form-item label="备注" prop="remark">
                 <lay-textarea placeholder="请输入备注" v-model="domainname.remark"></lay-textarea>
            </lay-form-item>
           
        </lay-form>
      </div>
    </lay-layer> 
  </template>
  
  <script  lang="ts" setup>
  import { ref, reactive, toRefs } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allDomainname,addDomainname,delDomainname,allPlatform} from '../../api'
  
  const visible11 = ref(false); 

  const selectedKeys = ref([]);
  
  const dataSource = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([
    { title: "序号", key: "id", align: "center" },
    { title: "域名", key: "domainName", align: "center"}, 
    { title: "绑定平台", key: "platformId", align: "center",customSlot: "platform" },  
    { title: "备注", key: "remark", align: "center" },
    { title: "添加时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  

  const platformArr = ref([]);

  const getAllPlatform = () => {
    var data = { "page":1, "limit": 200};
    allPlatform(data).then((res: any) => {
      if (res != "" && res.code == 0) {
        platformArr.value = res.data; 
      } else {
        platformArr.value = []; 
      }
      getAllDomainname();
    })
  }
  getAllPlatform();

  
  const getAllDomainname = () => {
    var data = { "page": page.current, "limit": page.limit};
    allDomainname(data).then((res: any) => {
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
   
  
  const domainname = reactive({
    id:0,
    domainName: "",
    platformId: "",
    remark: "",
   
  })
  
  const changeVisible11 = () => {
    domainname.id=0,
    domainname.domainName="",
    domainname.platformId="", 
    domainname.remark="", 
    visible11.value = !visible11.value;
  }
  
  const updateDomainname = (row: any) => {
    domainname.id=row.id,
    domainname.domainName=row.domainName,
    domainname.platformId=row.platformId,
    domainname.remark= row.remark, 
    visible11.value = !visible11.value;
  }
  
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addDomainname(JSON.stringify(domainname)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllDomainname();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false; 
      }
    }
  ])
  
   
  const deleteDomainname=(row:any,)=>{
    var data={'id':row.id} 
    delDomainname(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllDomainname();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
  
  }
  
  
   
  const getPlatformName=(id:any,)=> {
      const platform = platformArr.value.find(item => item.id == id);
      return platform ? platform.name : '未知平台';
    }
   
  </script>